import React from "react";
import VideoEmbed from "../VideoEmbed";
import { motion } from "framer-motion";

export default function HeroVideo() {
  return (
    <section
      id="how"
      data-testid="hero-video-section"
      className="section-light pt-16 pb-12 md:pt-24 md:pb-20"
    >
      <div className="container-xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-8 md:mb-12">
          <div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#86868B] mb-4">
              How it works · 90 seconds
            </div>
            <h2 className="font-display text-[#1D1D1F] text-3xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.02] font-semibold max-w-3xl">
              Your real B2B marketing pain{" "}
              <span className="font-serif italic font-light text-[#86868B]">
                isn&apos;t what you&apos;re solving.
              </span>
            </h2>
          </div>
          <p className="text-[#515154] text-base md:text-lg max-w-md leading-relaxed">
            A short look at how we diagnose, re-engineer, and scale B2B pipeline
            — with AI-led precision.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <VideoEmbed
            videoId="s2FiNcerYcI"
            title="Your real B2B marketing pain isn't what you're solving"
            testId="hero-video"
            theme="light"
          />
        </motion.div>
      </div>
    </section>
  );
}
